import { HttpStatusCode } from 'axios';

export interface ApiError {
	error: string;
	message: ErrorCode | ErrorCode[] | string | string[];
	status: HttpStatusCode;
}

export interface AppError {
	status: HttpStatusCode;
	stack: (ErrorCode | string)[];
	message: string;
}

export enum ErrorCode {
	GENERIC = 'genericError',
	INVALID_FILE_TYPE = 'cantUploadFileType',
	USER_NOT_FOUND = 'userNotFound',
	USER_NOT_ACTIVE = 'userNotActive',
	INVALID_EMAIL = 'emailIsNotValid',
	DUPLICATED_EMAIL = 'duplicatedEmail',
	MISSING_FIELD = 'missingField',
	PASSWORD_TO_WEAK = 'passwordToWeak',
	INVALID_PASSWORD = 'invalidPassword',
	INVALID_REFRESH_TOKEN = 'invalidRefreshToken',
	REFRESH_TOKEN_EXPIRED = 'refreshTokenExpired',
	INVALID_TOKEN = 'invalidToken',
	INVALID_HASH = 'invalidHash',
	INVALID_POSTAL_CODE = 'invalidPostalCode',
	PRODUCT_CANNOT_BE_UPDATED = 'productCannotBeUpdated',
	DUPLICATED_NAME = 'duplicatedName',
	TOO_MANY_REQUESTS = 'tooManyRequests',
}

export const getErrorMessage = (codes: ErrorCode[] | string[]) => {
	const codeToMessage = (code: ErrorCode | string) => {
		switch (code) {
			case ErrorCode.GENERIC:
				return 'Something went wrong! Please try again later.';
			case ErrorCode.PASSWORD_TO_WEAK:
				return 'The password does not meet the security requirements!';
			case ErrorCode.INVALID_FILE_TYPE:
				return 'Unsupported file format!';
			case ErrorCode.USER_NOT_FOUND:
				return 'This email address is not registered in the system.';
			case ErrorCode.INVALID_PASSWORD:
				return 'The password you entered is incorrect!';
			case ErrorCode.DUPLICATED_EMAIL:
				return 'This email address is already taken!';
			case ErrorCode.INVALID_REFRESH_TOKEN:
				return 'Invalid token!';
			case ErrorCode.REFRESH_TOKEN_EXPIRED:
				return 'The token has expired!';
			case ErrorCode.INVALID_TOKEN:
				return 'Invalid token provided!';
			case ErrorCode.INVALID_HASH:
				return 'Invalid token provided!';
			case ErrorCode.MISSING_FIELD:
				return 'One of the required fields is missing!';
			case ErrorCode.DUPLICATED_NAME:
				return 'This name is already taken!';
			default:
				return '';
		}
	};

	const errorMessages = codes.map((code) => codeToMessage(code));

	const message =
		errorMessages.filter((m) => !!m).join('. ') ||
		'Something went wrong! Please try again later.';

	return message;
};
